var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import { Form, notification } from 'antd';
// @ts-ignore
import Button from '@fp-suite/core-ui/src/components/Button';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultScale, getDefaultScale, getScaleList, userSelector } from '../redux/authSlice';
import { startQZConnectionForPacking } from '../helper/functions';
import { useTranslation } from 'react-i18next';
// @ts-ignore
import qz from 'qz-tray';
import { useLocalNetworkPermission } from '../hooks/useLocalNetworkPermission';
import { LocalNetworkPermissionModal } from './LocalNetworkPermissionModal';
var ScalePreference = function (_a) {
    var setIsLoading = _a.setIsLoading, _b = _a.hostname, hostname = _b === void 0 ? null : _b;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var form = React.createRef();
    var _c = useState(''), scale = _c[0], setScale = _c[1];
    var _d = useState(null), deviceHostname = _d[0], setDeviceHostname = _d[1];
    var scaleList = useSelector(userSelector).scaleList;
    // Attempt QZ Tray connection to trigger the browser's local-network-access dialog
    var handleRequestPermission = useCallback(function () { return __awaiter(void 0, void 0, Promise, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, startQZConnectionForPacking(function () { })];
                case 1:
                    _c.sent();
                    return [2 /*return*/, !!((_b = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _b === void 0 ? void 0 : _b.isActive())];
                case 2:
                    _a = _c.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    var _e = useLocalNetworkPermission(handleRequestPermission), guardQzAction = _e.guardQzAction, modalVisible = _e.modalVisible, modalStatus = _e.modalStatus, onRequestPermission = _e.onRequestPermission, onCloseModal = _e.onCloseModal;
    useEffect(function () {
        var initScaleData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var detectedHostname, device, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, startQZConnectionForPacking(function () { })];
                    case 1:
                        _b.sent();
                        detectedHostname = null;
                        if (!(((_a = qz === null || qz === void 0 ? void 0 : qz.websocket) === null || _a === void 0 ? void 0 : _a.isActive()) && qz.networking && typeof qz.networking.device === 'function')) return [3 /*break*/, 6];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, qz.networking.device()];
                    case 3:
                        device = _b.sent();
                        detectedHostname = device === null || device === void 0 ? void 0 : device.hostname;
                        setDeviceHostname(detectedHostname);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        console.error('Error getting device hostname:', e_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        notification['error']({
                            message: t('Error'),
                            description: t('QZ Tray is not connected. Continuing without QZ connection.')
                        });
                        _b.label = 7;
                    case 7:
                        dispatch(getDefaultScale({ setScale: setScale }));
                        dispatch(getScaleList());
                        return [2 /*return*/];
                }
            });
        }); };
        initScaleData(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var _a;
        if (scaleList && scaleList.length > 0) {
            (_a = form.current) === null || _a === void 0 ? void 0 : _a.setFieldsValue({
                scale_Id: scaleList.some(function (item) { return item === null || item === void 0 ? void 0 : item.key; }) ? scale : []
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scaleList]);
    var setScaleId = function (scaleComputerId) {
        var _a;
        setIsLoading(true);
        (_a = form.current) === null || _a === void 0 ? void 0 : _a.setFieldsValue({ scaleComputerId: scaleComputerId });
        if (!deviceHostname) {
            notification['warning']({
                message: t('Warning'),
                description: t('No device hostname detected. Scale preference may not be saved correctly.')
            });
        }
        console.log('Setting scale preference, with hostname:', deviceHostname);
        dispatch(setDefaultScale({ scaleComputerId: scaleComputerId, hostname: deviceHostname }));
        setIsLoading(false);
    };
    var selectedScaleList = function (value) {
        var _a;
        setIsLoading(true);
        setScale(value);
        (_a = form.current) === null || _a === void 0 ? void 0 : _a.setFieldsValue({ scale_Id: value });
        setIsLoading(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: 'px-4 sm:px-8 lg:px-16 pt-1 lg:pt-3 pb-4 md:h-screen sm:h-auto w-full sm:w-4/5 md:w-3/5 lg:w-2/5' }, { children: _jsxs("div", __assign({ className: 'bg-white p-5 pb-0.5 rounded-lg shadow-sm' }, { children: [_jsx("h1", __assign({ className: 'font-bold text-base mb-7' }, { children: t('Set Scale Preference') }), void 0), _jsx("div", __assign({ className: 'w-11/12 mx-auto' }, { children: _jsxs(Form, __assign({ ref: form, initialValues: { scale_Id: scale } }, { children: [_jsx(Form.Item, __assign({ name: 'scale_Id', rules: [{ required: true, message: t('Select the Scale!') }] }, { children: _jsx(Dropdown, { title: t('Select Scale'), placeholder: t('select scale'), data: scaleList, onChange: selectedScaleList }, void 0) }), void 0), _jsx(Form.Item, { children: _jsx("div", __assign({ className: 'flex flex-col' }, { children: _jsx(Button, { buttonText: t('Set'), onClick: function () {
                                                    guardQzAction(function () { return __awaiter(void 0, void 0, void 0, function () {
                                                        var scaleExists;
                                                        return __generator(this, function (_a) {
                                                            setScaleId(scale);
                                                            scaleExists = scaleList === null || scaleList === void 0 ? void 0 : scaleList.some(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === scale; });
                                                            if (scaleExists) {
                                                                notification['success']({
                                                                    message: t('Success'),
                                                                    description: t('Successfully set default Scale!')
                                                                });
                                                            }
                                                            return [2 /*return*/];
                                                        });
                                                    }); });
                                                } }, void 0) }), void 0) }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0), _jsx(LocalNetworkPermissionModal, { visible: modalVisible, status: modalStatus, onClose: onCloseModal, onRequestPermission: onRequestPermission }, void 0)] }, void 0));
};
export default ScalePreference;
